import React from 'react';

export const IdentiteTab = ({ data, setData }) => {
  const updateField = React.useCallback((section, field, value) => {
    if (section === 'jalons') {
      setData(prev => ({
        ...prev,
        identite: {
          ...prev.identite,
          jalons: {
            ...prev.identite?.jalons,
            [field]: value
          }
        }
      }));
    } else {
      setData(prev => ({
        ...prev,
        identite: {
          ...prev.identite,
          [field]: value
        }
      }));
    }
  }, [setData]);

  return (
    <div className="space-y-8">
      {/* INFOS ADMINISTRATIVES */}
      <div>
        <h3 className="text-lg font-semibold text-blue-700 mb-4 border-b border-blue-200 pb-2">
          INFOS ADMINISTRATIVES - À remplir par le commerce
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Entité contractante - Nom du client (indiqué sur le contrat)
            </label>
            <input
              type="text"
              value={data.entiteContractante || ''}
              onChange={(e) => updateField('', 'entiteContractante', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Modèle économique
            </label>
            <input
              type="text"
              value={data.modeleEconomique || ''}
              onChange={(e) => updateField('', 'modeleEconomique', e.target.value)}
              placeholder="ajouter licence logicielle ou abonnement logiciel"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Mode d'hébergement
            </label>
            <input
              type="text"
              value={data.modeHebergement || ''}
              onChange={(e) => updateField('', 'modeHebergement', e.target.value)}
              placeholder="On Premise ou hébergé (AZ Networks), exclusif ou partagé"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Signature du contrat principal
            </label>
            <input
              type="date"
              value={data.signatureContratPrincipal || ''}
              onChange={(e) => updateField('', 'signatureContratPrincipal', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Modules achetés
            </label>
            <textarea
              value={data.modulesAchetes || ''}
              onChange={(e) => updateField('', 'modulesAchetes', e.target.value)}
              rows="3"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
      </div>

      {/* INFORMATION EQUIPE HOPPEN */}
      <div>
        <h3 className="text-lg font-semibold text-green-700 mb-4 border-b border-green-200 pb-2">
          INFORMATION ÉQUIPE HOPPEN
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Commercial</label>
            <input
              type="text"
              value={data.commercial || ''}
              onChange={(e) => updateField('', 'commercial', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Avant Vente</label>
            <input
              type="text"
              value={data.avantVente || ''}
              onChange={(e) => updateField('', 'avantVente', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">CSM</label>
            <input
              type="text"
              value={data.csm || ''}
              onChange={(e) => updateField('', 'csm', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
      </div>

      {/* INFORMATION CLIENT */}
      <div>
        <h3 className="text-lg font-semibold text-purple-700 mb-4 border-b border-purple-200 pb-2">
          INFORMATION CLIENT - À remplir par le commerce
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Nom de l'établissement (ou des établissements)
            </label>
            <input
              type="text"
              value={data.nomEtablissement || ''}
              onChange={(e) => updateField('', 'nomEtablissement', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Code interne</label>
            <input
              type="text"
              value={data.codeInterne || ''}
              onChange={(e) => updateField('', 'codeInterne', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Adresse accueil</label>
            <input
              type="text"
              value={data.adresseAccueil || ''}
              onChange={(e) => updateField('', 'adresseAccueil', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Adresse livraison (pour les bornes)
            </label>
            <input
              type="text"
              value={data.adresseLivraison || ''}
              onChange={(e) => updateField('', 'adresseLivraison', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">N° téléphone</label>
            <input
              type="tel"
              value={data.telephone || ''}
              onChange={(e) => updateField('', 'telephone', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">N° SIRET</label>
            <input
              type="text"
              value={data.siret || ''}
              onChange={(e) => updateField('', 'siret', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">N° TVA</label>
            <input
              type="text"
              value={data.tva || ''}
              onChange={(e) => updateField('', 'tva', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
      </div>

      {/* Système d'Information Client */}
      <div>
        <h3 className="text-lg font-semibold text-orange-700 mb-4 border-b border-orange-200 pb-2">
          Système d'Information Client
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">GAP</label>
            <input
              type="text"
              value={data.gap || ''}
              onChange={(e) => updateField('', 'gap', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">DPI</label>
            <input
              type="text"
              value={data.dpi || ''}
              onChange={(e) => updateField('', 'dpi', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Agenda</label>
            <input
              type="text"
              value={data.agenda || ''}
              onChange={(e) => updateField('', 'agenda', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
      </div>

      {/* INFORMATION CONTEXTE ES */}
      <div>
        <h3 className="text-lg font-semibold text-teal-700 mb-4 border-b border-teal-200 pb-2">
          INFORMATION CONTEXTE ES - À remplir par le commerce
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Nom des sites</label>
            <input
              type="text"
              value={data.nomSites || ''}
              onChange={(e) => updateField('', 'nomSites', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Nombre de lits</label>
            <input
              type="number"
              value={data.nombreLits || ''}
              onChange={(e) => updateField('', 'nombreLits', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Nombre de séjours annuels</label>
            <input
              type="number"
              value={data.nombreSejoursAnnuels || ''}
              onChange={(e) => updateField('', 'nombreSejoursAnnuels', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
      </div>

      {/* PARTICULARITÉS PROJET */}
      <div>
        <h3 className="text-lg font-semibold text-red-700 mb-4 border-b border-red-200 pb-2">
          PARTICULARITÉS PROJET - À remplir par le commerce
        </h3>
        <div className="grid grid-cols-1 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">SLA</label>
            <input
              type="text"
              value={data.sla || ''}
              onChange={(e) => updateField('', 'sla', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Développements spécifiques (préciser ceux obligatoires et mentionnés contrat)
            </label>
            <textarea
              value={data.devSpecifiques || ''}
              onChange={(e) => updateField('', 'devSpecifiques', e.target.value)}
              rows="3"
              placeholder="spécificité client type HVS linus"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Autres</label>
            <textarea
              value={data.autres || ''}
              onChange={(e) => updateField('', 'autres', e.target.value)}
              rows="2"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
      </div>

      {/* ENVIRONNEMENTS CLIENT */}
      <div>
        <h3 className="text-lg font-semibold text-indigo-700 mb-4 border-b border-indigo-200 pb-2">
          ENVIRONNEMENTS CLIENT - À remplir par le projet
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              URL Portail patient prod
            </label>
            <input
              type="url"
              value={data.urlPortailPatientProd || ''}
              onChange={(e) => updateField('', 'urlPortailPatientProd', e.target.value)}
              placeholder='Voir onglet "fiche d\installation"'
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              URL Portail patient qual
            </label>
            <input
              type="url"
              value={data.urlPortailPatientQual || ''}
              onChange={(e) => updateField('', 'urlPortailPatientQual', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              URL Portail soignant prod
            </label>
            <input
              type="url"
              value={data.urlPortailSoignantProd || ''}
              onChange={(e) => updateField('', 'urlPortailSoignantProd', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              URL Portail soignant qual
            </label>
            <input
              type="url"
              value={data.urlPortailSoignantQual || ''}
              onChange={(e) => updateField('', 'urlPortailSoignantQual', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Nom de l'application mobile
            </label>
            <input
              type="text"
              value={data.nomAppMobile || ''}
              onChange={(e) => updateField('', 'nomAppMobile', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
      </div>

      {/* MODALITÉS ACCÈS CLIENT */}
      <div>
        <h3 className="text-lg font-semibold text-pink-700 mb-4 border-b border-pink-200 pb-2">
          MODALITÉS ACCÈS CLIENT - À remplir par le commerce
        </h3>
        <div className="grid grid-cols-1 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Process d'intervention dans le cadre d'un déploiement
            </label>
            <textarea
              value={data.processDeploiement || ''}
              onChange={(e) => updateField('', 'processDeploiement', e.target.value)}
              rows="3"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Processus d'intervention dans le cadre d'une maintenance
            </label>
            <textarea
              value={data.processMaintenance || ''}
              onChange={(e) => updateField('', 'processMaintenance', e.target.value)}
              rows="3"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Processus d'intervention dans le cadre d'une urgence
            </label>
            <textarea
              value={data.processUrgence || ''}
              onChange={(e) => updateField('', 'processUrgence', e.target.value)}
              rows="3"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
      </div>

      {/* JALONS - Section séparée à droite */}
      <div>
        <h3 className="text-lg font-semibold text-gray-700 mb-4 border-b border-gray-400 pb-2">
          JALONS - À remplir par le commerce (Dates - À remplir par le Projet)
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Signature du contrat
            </label>
            <input
              type="date"
              value={data.jalons?.signatureContrat || ''}
              onChange={(e) => updateField('jalons', 'signatureContrat', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Passation vente - chef de projet
            </label>
            <input
              type="date"
              value={data.jalons?.passationVenteChefProjet || ''}
              onChange={(e) => updateField('jalons', 'passationVenteChefProjet', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Nom du module déployé
            </label>
            <input
              type="text"
              value={data.jalons?.nomModuleDeploye || ''}
              onChange={(e) => updateField('jalons', 'nomModuleDeploye', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Chef de projet module
            </label>
            <input
              type="text"
              value={data.jalons?.chefProjetModule || ''}
              onChange={(e) => updateField('jalons', 'chefProjetModule', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Kick-off client
            </label>
            <input
              type="date"
              value={data.jalons?.kickoffClient || ''}
              onChange={(e) => updateField('jalons', 'kickoffClient', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Cadrage Projet
            </label>
            <input
              type="date"
              value={data.jalons?.cadrageProjet || ''}
              onChange={(e) => updateField('jalons', 'cadrageProjet', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Signature MOM
            </label>
            <input
              type="date"
              value={data.jalons?.signatureMom || ''}
              onChange={(e) => updateField('jalons', 'signatureMom', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Signature VA
            </label>
            <input
              type="date"
              value={data.jalons?.signatureVa || ''}
              onChange={(e) => updateField('jalons', 'signatureVa', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Date mise en production
            </label>
            <input
              type="date"
              value={data.jalons?.dateMiseProduction || ''}
              onChange={(e) => updateField('jalons', 'dateMiseProduction', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Signature VSR
            </label>
            <input
              type="date"
              value={data.jalons?.signatureVsr || ''}
              onChange={(e) => updateField('jalons', 'signatureVsr', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Passation chef de projet - support
            </label>
            <input
              type="date"
              value={data.jalons?.passationChefProjetSupport || ''}
              onChange={(e) => updateField('jalons', 'passationChefProjetSupport', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Renouvellement maintenance
            </label>
            <input
              type="date"
              value={data.jalons?.renouvellementMaintenance || ''}
              onChange={(e) => updateField('jalons', 'renouvellementMaintenance', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
      </div>
    </div>
  );
};